import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-claim-type-edit',
  templateUrl: './claim-type-edit.component.html',
  styleUrls: ['./claim-type-edit.component.scss'],
  standalone: false,
})
export class ClaimTypeEditComponent implements OnInit {
  claimTypeId: number;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.claimTypeId = this.route.snapshot.params['id'];
  }
}
